import React from 'react';
import { REVIEW_FILTER, REVIEW_STATUS } from './importReview.model';
import styles from './ImportReview.module.css';

const FILTERS = [
	{ key: REVIEW_FILTER.ALL, label: 'Todas' },
	{ key: REVIEW_STATUS.READY, label: 'Listas' },
	{ key: REVIEW_STATUS.AUTO_CORRECTED, label: 'Auto-corregidas' },
	{ key: REVIEW_STATUS.REVIEW_REQUIRED, label: 'Revisión' },
	{ key: REVIEW_STATUS.BLOCKED, label: 'Bloqueadas' },
];

const ImportReviewSummary = ({
	summary,
	activeFilter,
	onChange,
	zoneCoverageChangeCount = 0,
	zoneCreationCount = 0,
	zoneCreationAffectedOrderCount = 0,
	disabled = false,
}) => (
	<>
		<section className={styles.summary} aria-label='Resumen de la importación'>
			{FILTERS.map(filter => (
				<button
					key={filter.key}
					type='button'
					className={`${styles.summaryCard} ${
						activeFilter === filter.key ? styles.summaryCardActive : ''
					}`}
					aria-pressed={activeFilter === filter.key}
					onClick={() => onChange(filter.key)}
					disabled={disabled}
				>
					<span className={styles.summaryValue}>
						{summary[filter.key] || 0}
					</span>
					<span className={styles.summaryLabel}>{filter.label}</span>
				</button>
			))}
		</section>
		{zoneCoverageChangeCount > 0 && (
			<aside className={styles.coverageNotice} role='note'>
				<span aria-hidden='true' className={styles.coverageNoticeIcon}>
					+
				</span>
				<div>
					<strong>
						{zoneCoverageChangeCount}{' '}
						{zoneCoverageChangeCount === 1
							? 'aprovisionamiento de cobertura'
							: 'aprovisionamientos de cobertura'}
					</strong>
					<p>
						Al confirmar la importación se crearán, reactivarán o normalizarán
						asignaciones AUZ tipo normal y coberturas AZD para GPON más el
						servicio. Es un mecanismo provisional; esta vista previa no modifica
						la cobertura.
					</p>
				</div>
			</aside>
		)}
		{zoneCreationCount > 0 && (
			<aside className={styles.zoneCreationNotice} role='note'>
				<span aria-hidden='true' className={styles.coverageNoticeIcon}>
					+
				</span>
				<div>
					<strong>
						{zoneCreationCount}{' '}
						{zoneCreationCount === 1 ? 'zona nueva' : 'zonas nuevas'} ·{' '}
						{zoneCreationAffectedOrderCount}{' '}
						{zoneCreationAffectedOrderCount === 1 ? 'orden' : 'órdenes'}
					</strong>
					<p>
						La vista previa no crea zonas. Se crearán o reutilizarán únicamente
						al confirmar la importación y después de validar el plan.
					</p>
				</div>
			</aside>
		)}
	</>
);

export default ImportReviewSummary;
